<style scoped lang="scss">

</style>

<template>
    <vk-modal class="preview-docs-modal" stack :show.sync="isOpen" v-if="url">
        <vk-modal-title slot="header">Preview Document</vk-modal-title>
        <div class="wrap uk-grid">
            <div class="uk-width-1-1 uk-margin-bottom">
                {{ document.filename }}
            </div>
            <div v-if="isValid" class="uk-width-1-1">
                <iframe v-if="isPdf" style="width: 100%; height: 800px;" :src="url" frameborder="0"></iframe>
                <div class="image-container" v-else>
                    <inner-image-zoom :src="rotatedUrl" />
                    <button class="uk-button uk-button-primary uk-align-right" @click="rotate(-90)">
                        <i class="a-rotate-right-2"></i>
                    </button>
                    <button class="uk-button uk-button-primary uk-align-right" @click="rotate(90)">
                        <i class="a-rotate-left"></i>
                    </button>
                </div>
            </div>
            <div v-else class="uk-tile uk-tile-muted uk-text-large uk-text-center uk-padding">
                No Preview Available For This File Type
            </div>
        </div>
        <div slot="footer" class="uk-text-right uk-grid-1-1">
            <vk-button type="primary" @click="onConfirm">{{ confirmText }}</vk-button>
        </div>
    </vk-modal>
</template>

<script>
    import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
    import InnerImageZoom from 'vue-inner-image-zoom';

    export default {
        name: "PreviewDocumentsModal",
        components: {InnerImageZoom},
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            cancelText: {
                type: String,
                default: 'Cancel',
            },
            confirmText: {
                type: String,
                default: 'Ok',
            },
        },

        computed: {
            isValid() {
                let isValid = false;
                let validExtensions = ['pdf', 'jpg', 'png', 'jpeg'];
                _.each(validExtensions, ext => {
                    if (this.document.filename.toLowerCase().indexOf('.' + ext) !== -1) {
                        isValid = true;
                    }
                })
                return isValid;
            },
            isPdf() {
                if (this.document) {
                    return this.document.filename.toLowerCase().indexOf('.pdf') !== -1;
                }

                return false;
            },
            rotatedUrl() {
                return this.url + '?rotate=' + this.rotation;
            },
        },
        data() {
            return {
                isOpen: false,
                document: null,
                url: null,

                panZoomOptions: {
                    minZoom: 0.5,
                    maxZoom: 5,
                },
                rotation: 0,
            }
        },
        watch: {
            show(newValue) {
                this.isOpen = newValue;
            }
        },
        mounted() {
            this.isOpen = this.show;
        },
        methods: {
            open(url, document) {
                console.log('opening');
                this.document = document;
                this.url = url;
                this.isOpen = true;
            },
            close() {
                this.isOpen = false;
            },
            onConfirm() {
                this.$emit('confirm');
                this.isOpen = false;
            },

            rotate(amount) {
                this.rotation += amount;
            }
        },
    }
</script>
